import { memo } from "react";
import PropTypes from "prop-types";
import { ListingHeaderImage } from "app/pages/.shared/ListingHeaderImage";
import { merchandisingShape, resolutionPropType } from "app/utils/propTypes";
import Merchandising from "app/pages/Listing/merchandising/Merchandising";
import MerchandisingCarousel from "@brand/MerchandisingCarousel/MerchandisingCarousel";
import "./HeroMerch.scss";
import isEqual from "lodash/isEqual";

const HeroMerch = ({ merchList = [], resolution }) => {
	const noMerch = merchList.length === 0;
	const onlyOneMerch = merchList.length === 1;
	const firstMerch = merchList?.[0];

	if (noMerch) {
		return null;
	}
	if (onlyOneMerch && firstMerch) {
		return (
			<div className="hero-merch" data-testid="hero-merch">
				<div className="hero-merch__container">
					<Merchandising
						imageElement={
							<ListingHeaderImage
								imgSrc={{
									desktop: {
										src: firstMerch?.photoLarge.url,
										thumbnail: firstMerch?.photoLarge.thumbnail,
									},
									mobile: {
										src: firstMerch?.photoSmall.url,
										thumbnail: firstMerch?.photoSmall.thumbnail,
									},
								}}
								resolution={resolution}
							/>
						}
						position={firstMerch.position}
						indexCarousel={firstMerch.headerIndex}
						ctaButtonText={firstMerch?.button?.label}
						ctaButtonBackgroundColor={firstMerch?.button?.backgroundColor}
						ctaButtonColor={firstMerch?.button?.color}
						merchandisingCode={firstMerch?.code}
						endAt={firstMerch?.endAt}
						countdownPosition={firstMerch?.countdown?.position}
						countdownTextColor={firstMerch?.countdown?.textColor}
						countdownStartAt={firstMerch?.countdown?.startAt}
						countdownEndAt={firstMerch?.countdown?.endAt}
						daysInHours={firstMerch?.countdown?.daysInHours}
						redirectUrl={firstMerch?.redirectUrl}
					/>
				</div>
			</div>
		);
	}

	return (
		<div className="hero-merch hero-merch--multiple" data-testid="hero-merch">
			<div className="hero-merch__container">
				<MerchandisingCarousel merchandisingList={merchList} resolution={resolution} />
			</div>
		</div>
	);
};

HeroMerch.propTypes = {
	resolution: resolutionPropType,
	merchList: PropTypes.arrayOf(merchandisingShape),
};

export default memo(HeroMerch, (prevProps, nextProps) => {
	return (
		isEqual(prevProps.merchList, nextProps.merchList) &&
		prevProps.resolution === nextProps.resolution
	);
});
